import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { textSizes } from 'theme/media'
import { IStyles } from '../../../theme'
import { color } from 'theme/tokens/color'

const deviceSettingsSyncContent: IStyles = {
    title: {
        fontSize: textSizes.normal,
    },
    switchWrapper: {
        display: 'flex',
        paddingBottom: 20,
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
    hint: {
        fontSize: textSizes.mini,
        color: color.fontDarkMedium,
        ...grid.mb_md,
    },
}

addStyles(deviceSettingsSyncContent)
export default deviceSettingsSyncContent
